import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IntercomInfoLink } from './IntercomInfoLink';
import { IntercomArticleKeys } from './types';

const Image = styled.img<{ src: any }>`
  width: 24px;
  height: 24px;
`;

const GutteredListItem = styled(ListItemButton)`
  padding-left: 13px;
  padding-right: 10px;
`;

const StyledListItemIcon = styled(ListItemIcon)`
  width: 24px;
  height: 24px;
  font-size: 1rem;
` as typeof ListItemIcon;

interface SideBarListItemProps {
  className: string | undefined;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  iconUrl: string;
  text: string | React.ReactNode;
  disabled?: boolean;
  intercomArticleKey?: IntercomArticleKeys;
}

export const SideBarListItem = React.forwardRef(function SideBarListItemRef(
  props: SideBarListItemProps,
  ref
) {
  const {
    className,
    onClick,
    iconUrl,
    text,
    disabled,
    intercomArticleKey,
    ...otherProps
  } = props;
  const { t } = useTranslation();
  return (
    <GutteredListItem
      {...otherProps}
      ref={ref as any}
      onClick={onClick}
      disabled={disabled ?? false}
      className={className}
      dense
      disableGutters
    >
      <StyledListItemIcon>
        <Image src={iconUrl} />
      </StyledListItemIcon>
      <ListItemText
        primary={
          <Typography noWrap variant="caption">
            {text}
          </Typography>
        }
        disableTypography
      />
      {intercomArticleKey ? (
        <IntercomInfoLink
          title={t('common:commonValues.tooltips.info')}
          tooltipPlacement="right"
          intercomArticleKey={intercomArticleKey}
        />
      ) : null}
    </GutteredListItem>
  );
});
